import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../../theme/partials'

const AppearancePage = lazy(() => import('./pages/AppearancePage'))
const OffersMediaPage = lazy(() => import('./pages/OffersMediaPage'))
const ServicesControlPage = lazy(() => import('./pages/ServicesControlPage'))
const FeaturesCardsPage = lazy(() => import('./pages/FeaturesCardsPage'))
const TermsConditionsPage = lazy(() => import('./pages/TermsConditionsPage'))
const AboutUsPage = lazy(() => import('./pages/AboutUsPage'))

export function PWAControlPage() {
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/pwa-control/appearance' component={AppearancePage} />
        <Route path='/pwa-control/offers-media' component={OffersMediaPage} />
        <Route path='/pwa-control/services-control' component={ServicesControlPage} />
        <Route path='/pwa-control/features-cards' component={FeaturesCardsPage} />
        <Route path='/pwa-control/terms-conditions' component={TermsConditionsPage} />
        <Route path='/pwa-control/about-us' component={AboutUsPage} />
        <Redirect to='/pwa-control/appearance' />
      </Switch>
    </Suspense>
  )
}

export default PWAControlPage
